import React, { useEffect, useState, useRef, useContext } from "react";
import { SimpleUtility } from "simple-ui-components";

import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import CheckIcon from "@mui/icons-material/Check";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";

import {
  BodyWrapperStyled,
  BoxStyled,
  CardStyled,
  CardHeader,
  CardBody,
} from "../../theme";
import { FilterEquipment } from "../dashboard/filterEquipment";
import { AuthContext } from "../authContextProvider";
import { post, get, del, put } from "../../server-requests/serverRequests";
import { getFilteredItem } from "../dashboard/dashboard";
import { InProgress } from "../shared/loading";
import { EquipmentDetailPopup } from "../dashboard/equipmentDetailPopup";
import { EquipmentsDetailWithAddRemove } from "./equipmentDetailWithAddRemove";
import { getTranslation } from "../languageProvider";
import { Log, getIndexNumber, ReplaceWord } from "../shared/utility";
import { useWindowSize } from "../layout/otherPage";

const filterSelectedEquipmentById = (selected, list) => {
  let listToReturn = [];
  for (let equipment of list) {
    let isExist = selected.some((item) => item.equipment.id === equipment.id);
    if (!isExist) {
      listToReturn = [...listToReturn, equipment];
    }
  }
  return listToReturn;
};

export const UpdateEquipments = ({
  equipmentListFull,
  Success,
  current,
  getSelected,
}) => {
  const equipmentDetailRef = useRef();
  const { UpdateObject } = SimpleUtility;

  const { popupHeight } = useWindowSize();

  const { snackbarHandler } = useContext(AuthContext);

  const [loading, setLoading] = useState({
    add: false,
    remove: false,
  });

  //filter by
  const [filter, setFilter] = useState({
    by: [],
    equipments: [],
    reload: false,
  });

  const [points, setPoints] = useState({
    list: [],
    reload: true,
  });

  // get selected Points
  useEffect(() => {
    let isMounted = true;
    if (points.reload) {
      let params = {
        routeId: current.id,
      };
      get("routes/points/list", params)
        .then((points) => {
          if (isMounted) {
            setLoading((prev) =>
              UpdateObject(prev, { remove: false, add: false })
            );
            setPoints((prev) =>
              UpdateObject(prev, { list: points, reload: false })
            );
            setFilter((prev) => UpdateObject(prev, { reload: true }));
          }
        })
        .catch((status) => {
          setLoading((prev) =>
            UpdateObject(prev, { remove: false, add: false })
          );
          snackbarHandler(getTranslation(`error${status}`));
          setPoints((prev) => UpdateObject(prev, { reload: false }));
          Log("Error on get routes/points/list" + status);
        });
    }
    return () => (isMounted = false);
  }, [points.reload, current, snackbarHandler, UpdateObject]);

  // filter equipment
  useEffect(() => {
    if (filter.reload) {
      let list = equipmentListFull;
      if (filter.by.brandId) {
        list = list.filter((item) => item.model.brand.id === filter.by.brandId);
      }
      if (filter.by.modelId) {
        list = list.filter((item) => item.model.id === filter.by.modelId);
      }
      if (filter.by.clientId) {
        if (filter.by.clientId !== "0") {
          list = list.filter(
            (item) => item.client && item.client.id === filter.by.clientId
          );
        } else {
          list = list.filter((item) => !item.client);
        }
      }
      if (filter.by.serialNumber && filter.by.serialNumber !== "") {
        list = list.filter((item) => {
          let text = item.serialNumber ? item.serialNumber.toUpperCase() : "";
          return text.includes(filter.by.serialNumber.toUpperCase());
        });
      }
      if (filter.by.observations && filter.by.observations !== "") {
        let searchList = filter.by.observations.split(",");
        list = getFilteredItem(list, searchList);
      }
      if (filter.by.stateId) {
        list = list.filter((item) => item.state.id === filter.by.stateId);
      }
      let reloadList = false;
      if (points.list.length > 0 && list.length > 0) {
        list = filterSelectedEquipmentById(points.list, list);
        reloadList = true;
      }
      setLoading((prev) => UpdateObject(prev, { remove: false, add: false }));
      setFilter((prev) =>
        UpdateObject(prev, { equipments: list, reload: reloadList })
      );
    }
  }, [filter.reload, equipmentListFull, filter.by, points.list, UpdateObject]);

  const filterEquipmentChangeHandler = (filterBy) => {
    setLoading((prev) => UpdateObject(prev, { remove: false, add: false }));
    setFilter((prev) => UpdateObject(prev, { by: filterBy, reload: true }));
  };

  const addEquipmentClickHandler = (equipment) => {
    setLoading((prev) => UpdateObject(prev, { remove: true, add: true }));
    if (points.list.length + 1 > 25) {
      snackbarHandler(getTranslation("0135"), "warning");
    } else {
      let toSend = {
        equipmentId: equipment.id,
        routeId: current.id,
        index: Number(getIndexNumber(points.list)),
      };
      post("routes/points", toSend)
        .then(() => {
          setPoints((prev) => UpdateObject(prev, { reload: true }));
          Success();
        })
        .catch((status) => {
          setLoading((prev) => UpdateObject(prev, { add: false }));
          snackbarHandler(getTranslation(`error${status}`));
          Log("Error: update routes" + status);
        });
    }
  };

  const removeEquipmentClickHandler = (id) => {
    setLoading((prev) => UpdateObject(prev, { remove: true, add: true }));
    del("routes/points", { id })
      .then(() => {
        setPoints((prev) => UpdateObject(prev, { reload: true }));
        Success();
      })
      .catch((status) => {
        setLoading((prev) => UpdateObject(prev, { remove: false, add: false }));
        snackbarHandler(getTranslation(`error${status}`));
        Log("Error: update routes" + status);
      });
  };

  const equipmentSelectHandler = (equipment) =>
    equipmentDetailRef.current.Detail(equipment);

  const changeEquipmentIndexHandel = (
    action,
    localIndex,
    indexValue,
    pointId
  ) => {
    let toChanged = [];
    if (action === "up") {
      let previousPointIndexValue = points.list[localIndex - 1].index;
      let previousPointId = points.list[localIndex - 1].id;
      toChanged = [
        { id: pointId, index: previousPointIndexValue },
        { id: previousPointId, index: indexValue },
      ];
    } else {
      let nextPointIndexValue = points.list[localIndex + 1].index;
      let nextPointId = points.list[localIndex + 1].id;
      toChanged = [
        { id: pointId, index: nextPointIndexValue },
        { id: nextPointId, index: indexValue },
      ];
    }
    for (let point of toChanged) {
      put(
        "routes/points/index",
        { index: Number(point.index) },
        { id: point.id }
      )
        .then(() => {
          setPoints((prev) => UpdateObject(prev, { reload: true }));
          Success();
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
        });
    }
  };

  return (
    <>
      <BodyWrapperStyled>
        <BoxStyled width="sm" col="2" fullHeight>
          <CardStyled>
            <CardHeader>
              <FilterListOutlinedIcon className="mainIcon" />
              <div className="detail" data-translate="0076">
                {getTranslation("0076")}
                <span data-translate="0071,0077">
                  {ReplaceWord(
                    getTranslation("0077"),
                    "**LIST**",
                    getTranslation("0071")
                  )}
                </span>
              </div>
            </CardHeader>
            <CardBody height={popupHeight}>
              <FilterEquipment Filter={filterEquipmentChangeHandler} />
            </CardBody>
          </CardStyled>
        </BoxStyled>
        <BoxStyled width="lg" col="2" fullHeight>
          <BodyWrapperStyled>
            <BoxStyled width="md" col="2" noMargin>
              <CardStyled>
                <CardHeader>
                  <DevicesOutlinedIcon className="mainIcon" />
                  <div className="detail" data-translate="0071">
                    {getTranslation("0071")}s
                    <span data-translate="0071,0078">
                      {ReplaceWord(
                        getTranslation("0078"),
                        "**NUMBER**",
                        filter.equipments.length,
                        "**LISTNAME**",
                        getTranslation("0071").toLowerCase() + "s"
                      )}
                    </span>
                  </div>
                </CardHeader>
                <CardBody height={popupHeight} position={loading.add}>
                  {loading.add && <InProgress />}
                  {filter.equipments.length > 0 &&
                    !loading.add &&
                    filter.equipments.map((equipment) => (
                      <EquipmentsDetailWithAddRemove
                        key={equipment.id}
                        equipment={equipment}
                        Add={addEquipmentClickHandler}
                        Select={equipmentSelectHandler}
                      />
                    ))}
                </CardBody>
              </CardStyled>
            </BoxStyled>
            <BoxStyled width="md" col="2" noMargin>
              <CardStyled>
                <CardHeader>
                  <CheckIcon className="mainIcon" />
                  <div className="detail" data-translate="0137">
                    {getTranslation("0137")}
                    <span data-translate="0035,0078">
                      {ReplaceWord(
                        getTranslation("0078"),
                        "**NUMBER**",
                        points.list.length,
                        "**LISTNAME**",
                        getTranslation("0035").toLowerCase() + "s"
                      )}
                    </span>
                  </div>
                </CardHeader>
                <CardBody height={popupHeight} position={loading.remove}>
                  {loading.remove && <InProgress />}
                  {points.list.length > 0 &&
                    points.list.map((point, index) => (
                      <EquipmentsDetailWithAddRemove
                        key={point.id}
                        equipment={point.equipment}
                        Select={equipmentSelectHandler}
                        length={points.list.length}
                        index={index}
                        indexPoint={point.index}
                        pointId={point.id}
                        Remove={removeEquipmentClickHandler}
                        isStarted={point.started}
                        SwitchIndex={changeEquipmentIndexHandel}
                      />
                    ))}
                </CardBody>
              </CardStyled>
            </BoxStyled>
          </BodyWrapperStyled>
        </BoxStyled>
      </BodyWrapperStyled>
      <EquipmentDetailPopup ref={equipmentDetailRef} />
    </>
  );
};
